import { Component, OnInit, signal } from '@angular/core';
import { OrganizationStoreService } from '../../../../shared/services/organization-store.service';
import { UserStoreService } from '../../../../shared/services/user-store.service';
import { ApiUserService } from '../../../../shared/services/api-user.service';
import { AuthService } from '../../../../shared/auth/auth.service';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '../../../../core/layout/components/breadcrumb/breadcrumb.component';
import { ApiOrganization } from '../../../../shared/services/api-organization.service';

@Component({
  selector: 'app-organizations-management',
  templateUrl: './organizations-management.component.html',
  styleUrls: ['./organizations-management.component.css'],
  imports: [
    CommonModule,
    BreadcrumbComponent
  ]
})
export class OrganizationsManagementComponent implements OnInit {
  copiedText = signal<string | null>(null);
  changingOrganizationId = signal<string | null>(null);
  organizationChangeError = signal<string | null>(null);

  constructor(
    public organizationStore: OrganizationStoreService,
    private userStore: UserStoreService,
    private apiUserService: ApiUserService,
    private authService: AuthService,
  ) { }

  ngOnInit() {}

  selectOrganization(org: ApiOrganization): void {
    if (this.changingOrganizationId()) return;
    this.organizationChangeError.set(null);
    this.changingOrganizationId.set(org.id);

    this.apiUserService.changeOrganization(org.id).subscribe({
      next: (response) => {
        this.userStore.setActiveOrg(response.activeOrg);

        // The backend maps activeOrg into Keycloak, so the token we're currently holding still
        // carries the old org claim — force a fresh one before committing the switch locally.
        this.authService.refreshToken(-1).finally(() => {
          this.changingOrganizationId.set(null);
          this.organizationStore.setOrganization(org);
        });
      },
      error: () => {
        this.changingOrganizationId.set(null);
        this.organizationChangeError.set('Failed to switch organization. Please try again.');
      }
    });
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.copiedText.set(text);
      setTimeout(() => this.copiedText.set(null), 1500);
    });
  }
}